import Vue from 'vue';
import Router from 'vue-router';
import Index from '@/pages/Index';
import Attiva from '@/pages/Attiva';
import Login from '@/pages/Login';
import Recover from '@/pages/Recover';
import Logout from '@/pages/Logout';
import Download from '@/pages/Download';
import Base from '@/pages/AreaRiservata/Base';
import Conferma from '@/pages/AreaRiservata/Conferma';
import Profilo from '@/pages/AreaRiservata/Profilo';
import Piani from '@/pages/AreaRiservata/Piani';
import Richieste from '@/pages/AreaRiservata/Richieste';
import Tickets from '@/pages/AreaRiservata/Tickets';

import auth from '@/authManager';

Vue.use(Router);

const router = new Router({
  linkActiveClass: 'cat__menu-left__item--active',
  scrollBehavior: () => ({ y: 0 }),
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index,
    },
    {
      path: '/attiva',
      name: 'Attiva',
      component: Attiva,
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
    },
    {
      path: '/recover',
      name: 'Recupera password',
      component: Recover,
    },
    {
      path: '/logout',
      name: 'Logout',
      component: Logout,
    },
    {
      path: '/download',
      name: 'Download',
      component: Download,
    },
    {
      path: '/area-riservata',
      name: 'Area Riservata',
      component: Base,
      children: [
        {
          path: '/area-riservata/conferma',
          name: 'Profilo',
          component: Conferma,
          meta: {
            title: 'Conferma Dati',
            requiresAuth: true,
            skip_redirect: true,
          },
        },
        {
          path: '/area-riservata/profilo',
          name: 'Profilo',
          component: Profilo,
          meta: {
            title: 'Profilo',
            requiresAuth: true,
          },
        },
        {
          path: '/area-riservata/piani',
          name: 'Piani',
          component: Piani,
          meta: {
            title: 'Piani',
            requiresAuth: true,
          },
        },
        {
          path: '/area-riservata/richieste',
          name: 'Richieste',
          component: Richieste,
          props: true,
          meta: {
            title: 'Richieste',
            requiresAuth: true,
          },
        },
        {
          path: '/area-riservata/tickets',
          name: 'Tickets',
          component: Tickets,
          props: true,
          meta: {
            title: 'Richieste',
            requiresAuth: true,
          },
        },
      ],
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.meta.title) document.title = `CWM - ${to.meta.title}`;

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!auth.isLoggedIn()) {
      next({
        path: '/login',
        query: { redirect: to.fullPath },
      });
    } else if (!auth.isProfileConfirmed() && !to.meta.skip_redirect) {
      return next({
        path: '/area-riservata/conferma',
      });
    }
  }

  return next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js